import React from 'react';
import { IconButton, Typography, Box, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';

const changelogData = [
  {
    version: "1.1",
    date: "25.06.2026",
    changes: [
      "✨ Вкладка Ченджлогу.",  
      "🛡️ Виправлено критичну вразливість клієнтської авторизації (перевірка сесій перенесена на серверну частину).",
      "🔒 Покращено захист маршрутів панелі адміністратора від несанкціонованого доступу."
    ]
  },
  {
    version: "1.0",
    date: "23.06.2026",
    changes: [
      "🚀 Офіційний реліз проєкту.",
      "🌐 Портування бота-помічника на веб-сайт.",
    ]
  }
];

const ChangelogModal = ({ onClose, isDarkMode }) => {
  return (
    <div className="bot-modal-overlay">
      <div className="bot-modal-content" style={{ maxWidth: '550px' }}>
        <IconButton className="modal-close-btn" onClick={onClose} sx={{ color: isDarkMode ? '#9ca3af' : '#64748b' }}>
          <CloseIcon />
        </IconButton>

        <Box className="modal-header-wrapper" sx={{ mb: 2 }}>
          <HistoryIcon className="modal-header-icon" sx={{ color: '#3b82f6', fontSize: 32, mb: 1 }} />
          <Typography variant="h5" className="modal-header-title">Список змін (Changelog)</Typography>
          <Typography variant="body2" className="modal-subtitle" sx={{ color: isDarkMode ? '#9ca3af' : '#64748b' }}>
            Історія оновлень та покращень нашого бота
          </Typography>
        </Box>

        <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
          {changelogData.map((log, index) => (
            <Box key={index} sx={{ mb: 3, textAlign: 'left' }}>
              <Typography variant="h6" sx={{ color: isDarkMode ? '#f8fafc' : '#0f172a', fontWeight: 'bold' }}>
                Версія {log.version} <span style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: 'normal', marginLeft: '8px' }}>({log.date})</span>
              </Typography>
              <Divider sx={{ my: 1, borderColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />
              <ul style={{ paddingLeft: '20px', color: isDarkMode ? '#cbd5e1' : '#334155', margin: 0, lineHeight: 1.6 }}>
                {log.changes.map((change, i) => (
                  <li key={i} style={{ marginBottom: '8px' }}>{change}</li>
                ))}
              </ul>
            </Box>
          ))}
        </Box>
      </div>
    </div>
  );
};

export default ChangelogModal;